"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importStar(require("../Button"));
var Burger_1 = __importDefault(require("./Burger"));
var HeaderMenu_1 = __importDefault(require("./HeaderMenu"));
var config_1 = require("../config");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.unlistenCallback = function () {
            // if locationListener is not provided by props is just empty function
        };
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.locationListener) {
            this.unlistenCallback = this.props.locationListener(function () {
                _this.setState({
                    open: false,
                });
            });
        }
    };
    Header.prototype.componentWillUnmount = function () {
        this.unlistenCallback();
    };
    Header.prototype.render = function () {
        var _a = this.props, children = _a.children, cta = _a.cta, logoClick = _a.logoClick, profile = _a.profile, info = _a.info;
        var b = config_1.block("header");
        var userLogged = profile !== undefined && profile.items.length > 0;
        return (react_1.default.createElement("div", { className: b() },
            react_1.default.createElement("div", { className: b("logo"), onClick: logoClick }),
            react_1.default.createElement("div", { className: b("menu") }, userLogged ? children : null),
            userLogged && cta && cta.button && (react_1.default.createElement("div", { className: b("cta") },
                react_1.default.createElement(Button_1.default, { small: true, variant: Button_1.ButtonVariant.Active, onClick: cta.onClick }, cta.button))),
            userLogged && info && react_1.default.createElement(HeaderMenu_1.default, __assign({}, info, { className: b("headermenu").mix(info.className) })),
            userLogged && profile && react_1.default.createElement(HeaderMenu_1.default, __assign({}, profile, { className: b("headermenu").mix(profile.className) })),
            userLogged && react_1.default.createElement(Burger_1.default, { className: b("burger") })));
    };
    return Header;
}(react_1.Component));
exports.default = Header;
//# sourceMappingURL=index.js.map